export var ChildProgressObservationStatus;
(function (ChildProgressObservationStatus) {
    ChildProgressObservationStatus[ChildProgressObservationStatus["NotStarted"] = 0] = "NotStarted";
    ChildProgressObservationStatus[ChildProgressObservationStatus["Started"] = 1] = "Started";
    ChildProgressObservationStatus[ChildProgressObservationStatus["Completed"] = 2] = "Completed";
})(ChildProgressObservationStatus || (ChildProgressObservationStatus = {}));
//# sourceMappingURL=child-progress-observation-status.js.map